import type { IndicadoresPiloto } from "@/types/piloto";

interface PilotIndicatorsProps {
  indicadores: IndicadoresPiloto;
}

interface KpiItem {
  label: string;
  value: string | number;
  icon: string;
  color: string;
  bgColor: string;
  borderColor: string;
}

export default function PilotIndicators({ indicadores }: PilotIndicatorsProps) {
  const kpis: KpiItem[] = [
    {
      label: "Total de Quadras",
      value: indicadores.totalQuadras,
      icon: "ri-grid-line",
      color: "text-primary-600",
      bgColor: "bg-primary-50",
      borderColor: "border-primary-200",
    },
    {
      label: "Árvores Cadastradas",
      value: indicadores.totalArvores,
      icon: "ri-plant-line",
      color: "text-accent-600",
      bgColor: "bg-accent-50",
      borderColor: "border-accent-200",
    },
    {
      label: "Cobertura Média de Copa",
      value: indicadores.coberturaCopaMedia === null ? "A calcular" : `${indicadores.coberturaCopaMedia}%`,
      icon: "ri-shield-check-line",
      color: "text-secondary-600",
      bgColor: "bg-secondary-50",
      borderColor: "border-secondary-200",
    },
    {
      label: "Quadras com Déficit",
      value: indicadores.quadrasComDeficit,
      icon: "ri-arrow-down-line",
      color: "text-warning-600",
      bgColor: "bg-warning-50",
      borderColor: "border-warning-200",
    },
    {
      label: "Árvores com Risco",
      value: indicadores.arvoresComRisco,
      icon: "ri-alert-line",
      color: "text-danger-600",
      bgColor: "bg-danger-50",
      borderColor: "border-danger-200",
    },
    {
      label: "Conflitos Urbanos",
      value: indicadores.arvoresComConflitoUrbano,
      icon: "ri-building-line",
      color: "text-warning-600",
      bgColor: "bg-warning-50",
      borderColor: "border-warning-200",
    },
    {
      label: "Prioridade Alta Plantio",
      value: indicadores.prioridadeAltaPlantio,
      icon: "ri-seedling-line",
      color: "text-primary-600",
      bgColor: "bg-primary-50",
      borderColor: "border-primary-200",
    },
    {
      label: "Espécies Identificadas",
      value: indicadores.especiesIdentificadas,
      icon: "ri-leaf-line",
      color: "text-accent-600",
      bgColor: "bg-accent-50",
      borderColor: "border-accent-200",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
      {kpis.map((kpi) => (
        <div
          key={kpi.label}
          className={`bg-white rounded-card border ${kpi.borderColor} p-3 flex flex-col gap-1.5 hover:shadow-sm transition-shadow`}
        >
          <div className={`w-7 h-7 rounded-lg ${kpi.bgColor} flex items-center justify-center shrink-0`}>
            <i className={`${kpi.icon} ${kpi.color} text-sm`}></i>
          </div>
          <div>
            <p className="text-lg font-bold text-foreground-900 font-heading leading-tight">{kpi.value}</p>
            <p className="text-[10px] text-foreground-500 leading-tight">{kpi.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
}